"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InteractionType;
(function (InteractionType) {
    InteractionType[InteractionType["NULL"] = 0] = "NULL";
    InteractionType[InteractionType["DELETE"] = 1] = "DELETE";
    InteractionType[InteractionType["CREATE_NODE"] = 2] = "CREATE_NODE";
    InteractionType[InteractionType["RENAME_NODE"] = 3] = "RENAME_NODE";
    InteractionType[InteractionType["MOVE_NODE"] = 4] = "MOVE_NODE";
    InteractionType[InteractionType["CREATE_EDGE"] = 5] = "CREATE_EDGE";
    InteractionType[InteractionType["SET_WEIGHT"] = 6] = "SET_WEIGHT";
    InteractionType[InteractionType["SELECT_SOURCE_NODE"] = 7] = "SELECT_SOURCE_NODE";
    InteractionType[InteractionType["SELECT_TARGET_NODE"] = 8] = "SELECT_TARGET_NODE";
    InteractionType[InteractionType["SELECT_MANDATORY_NODE"] = 9] = "SELECT_MANDATORY_NODE";
    InteractionType[InteractionType["SELECT_PREFIX_NODES"] = 10] = "SELECT_PREFIX_NODES";
    //Used for solving exercises
    InteractionType[InteractionType["HIGHLIGHT_NODE"] = 11] = "HIGHLIGHT_NODE";
    InteractionType[InteractionType["HIGHLIGHT_EDGE"] = 12] = "HIGHLIGHT_EDGE";
    InteractionType[InteractionType["HIGHLIGHT_PATH"] = 13] = "HIGHLIGHT_PATH";
    InteractionType[InteractionType["HIGHLIGHT_SIMPLE_PATH"] = 14] = "HIGHLIGHT_SIMPLE_PATH";
    InteractionType[InteractionType["HIGHLIGHT_VERTEX_COVER"] = 15] = "HIGHLIGHT_VERTEX_COVER";
    InteractionType[InteractionType["HIGHLIGHT_ALL"] = 16] = "HIGHLIGHT_ALL";
    InteractionType[InteractionType["UNDEFINED1"] = 17] = "UNDEFINED1";
    InteractionType[InteractionType["UNDEFINED2"] = 18] = "UNDEFINED2";
    InteractionType[InteractionType["UNDEFINED3"] = 19] = "UNDEFINED3";
    InteractionType[InteractionType["UNDEFINED4"] = 20] = "UNDEFINED4";
    InteractionType[InteractionType["UNDEFINED5"] = 21] = "UNDEFINED5";
    InteractionType[InteractionType["UNDEFINED6"] = 22] = "UNDEFINED6";
    InteractionType[InteractionType["UNDEFINED7"] = 23] = "UNDEFINED7";
    InteractionType[InteractionType["UNDEFINED8"] = 24] = "UNDEFINED8";
    InteractionType[InteractionType["UNDEFINED9"] = 25] = "UNDEFINED9";
})(InteractionType = exports.InteractionType || (exports.InteractionType = {}));
